import { axios } from "./axios";

const useAxios = () => axios;

export { useAxios };
